import { Component, OnInit, Inject, EventEmitter, Output, Input, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { QnSbnService } from '../../../services/qn-sbn-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import { QnSbnDataServiceService } from '../../../services/qn-sbn-data-service.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { OneWebComponentsAngularModule } from '@one/angular';
import { debounce, debounceTime, delay } from 'rxjs';
import { NotificationCommunicationService } from '../../notification-communication.service ';

@Component({
  selector: 'dl-delete-contact',
  standalone: true,
  imports: [OneWebComponentsAngularModule, FormsModule, ReactiveFormsModule],
  templateUrl: './delete-contact.component.html',
  styleUrls: ['./delete-contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteContactComponent implements OnInit {
  @Input() data: any;
  @Output() reasonSubmitted = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  @Input() required: boolean;

  public addCommentFC = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);
  public reason = new FormControl('', [Validators.required]);
  public placeholder="Additional Comments (Optional)";
  flag:boolean=false;
  name:any;
  localId:any;
  globalId:any;
  deletedData:any;
  contactNotificationId:any;
  notificationId:any;
  isProcessing = false;

  constructor(
    private snackBarNotification: SnackbarService,
    private qnsbnservice: QnSbnService,
    private cdr: ChangeDetectorRef,
    private commService: NotificationCommunicationService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue){
      this.deletedData=changes['data']?.currentValue[0];
      this.name=changes['data'].currentValue[0].map(i=>
        `"${i.CustomerContactName}"`
      ).join(', ')
      this.localId=`"${changes['data'].currentValue[0][0].LocalId}"`;
      this.globalId=changes['data'].currentValue[1] || "GlobalId";
      this.globalId=`"${this.globalId}"`;
      this.notificationId=changes['data'].currentValue[2];
      this.contactNotificationId=changes['data'].currentValue[0].map(i=>
        i.ContactNotificationId
      );
    }    
  }

  ngOnInit(): void {

  }

  changeStatePlaceholder(data){
    if(data==="Other"){
      this.flag=true;
      this.placeholder="Additional Comments (Required)"
      this.cdr.detectChanges();
    }
    else{
      this.flag=false;
      this.placeholder="Additional Comments (Optional)"
      this.cdr.detectChanges();
    }
  }

  typeListValue(event){
    this.changeStatePlaceholder(this.reason.value.length>0?this.reason.value[0]:"")
  }
  
  public confirmDeletion() {
    let commentText = this.addCommentFC.value;
    const sanitized = commentText.replace(/[^a-zA-Z\s]/g, '').replace(/\s+/g, ' ').trim();
    commentText = sanitized;
    if(this.reason.value.length==1){
      if(this.reason.value[0]==="Other"){
        if(commentText=="" && commentText.length==0){
          this.snackBarNotification.snackBarMessage('alarm', 'Comment is required. It cannot be empty.');
        }
        else if(commentText!="" && commentText.length<5){
          this.snackBarNotification.snackBarMessage('alarm', 'Comment is too short. Minimum length is 5 characters.');
        }
        else if(commentText!="" && commentText.length > 500){
          this.snackBarNotification.snackBarMessage('alarm', 'Comment is too long. Maximum length is 500 characters.');
        }
        else{
          this.isProcessing = true;
          this.commService.sendData({ flag: this.isProcessing });
          const deletePayload={
            "reason": this.reason.value[0],
            "comment": commentText,
            "notificationId": this.notificationId,
            "contactNotificationId": this.contactNotificationId
          }
          
          setTimeout(() => {
          this.qnsbnservice.deleteContact(deletePayload).pipe(delay(2000)).subscribe(
          (responseData: any) => {
            
            if (responseData.httpStatus === 200) {
              const sendResponse=[200,this.deletedData];
              this.reasonSubmitted.emit(sendResponse)
            }
            else if(responseData.errorMessage.length!=0){
              const sendResponse=[0];
              this.reasonSubmitted.emit(sendResponse)
            }
          },
          (error: HttpErrorResponse) => {
            const sendResponse=[0];
            this.reasonSubmitted.emit(sendResponse)
          }
        );
        }, 1000);
        }
      }
      else{
        if(commentText!="" && commentText.length<5){
          this.snackBarNotification.snackBarMessage('alarm', 'Comment is too short. Minimum length is 5 characters.');
        }
        else if(commentText!="" && commentText.length > 500){
          this.snackBarNotification.snackBarMessage('alarm', 'Comment is too long. Maximum length is 500 characters.');
        }
        else{
          this.isProcessing = true;
          this.commService.sendData({ flag: this.isProcessing });
          const deletePayload={
            "reason": this.reason.value[0],
            "comment": commentText,
            "notificationId": this.notificationId,
            "contactNotificationId": this.contactNotificationId
          }
          
          setTimeout(() => {
          this.qnsbnservice.deleteContact(deletePayload).pipe(delay(2000)).subscribe(
          (responseData: any) => {
            
            if (responseData.httpStatus === 200) {
              const sendResponse=[200,this.deletedData];
              this.reasonSubmitted.emit(sendResponse)
            }
            else if(responseData.errorMessage.length!=0){
              const sendResponse=[0];
              this.reasonSubmitted.emit(sendResponse)
            }
          },
          (error: HttpErrorResponse) => {
            const sendResponse=[0];
            this.reasonSubmitted.emit(sendResponse)
          }
        );
        }, 1000);
        }
      }
    }
  } 

  cancelClicked() {
    this.onClose.emit();
  }
}
